import { render, staticRenderFns } from "./dashTopPptList.vue?vue&type=template&id=31e7970a&scoped=true"
import script from "./dashTopPptList.vue?vue&type=script&lang=js"
export * from "./dashTopPptList.vue?vue&type=script&lang=js"
import style0 from "./dashTopPptList.vue?vue&type=style&index=0&id=31e7970a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e7970a",
  null
  
)

export default component.exports